import { Controller } from "@hotwired/stimulus"
import hotkeys from "hotkeys-js"

export default class extends Controller {
  static targets = ["list", "bulk_multiple", "details", "reply"]
  emailId = ""
  backUrl = ""
  listScrollPosition = 0
  emailScrollPosition = 0
  hideEmailClick = false

  connect() {
    console.log("navigation")
    // this.element.addEventListener("click", this.saveLocation.bind(this))

    this.handleStreamRender = this.handleStreamRender.bind(this)
    this.handlePopState = this.handlePopState.bind(this)
    // dzięki temu kliknięcie "cofnij" przeglądarkowego poprawnie wraca nam na listę maili
    window.addEventListener("popstate", this.handlePopState)
    window.addEventListener("turbo:before-stream-render", this.handleStreamRender)

    // scrollowanie do ostatniego rozwiniętego emaila (pierwszego nieodczytanego) w przypadku gdy weszliśmy do maila nie z listy
    if (document.querySelector("div[id=\"email-info\"]")) {
      const main = document.querySelector("div[id=\"email-info\"]")
      const divs = Array.from(main.querySelectorAll("div[data-email-target=\"email\""))
      const firstDiv = divs[0] || main
      const div = divs.reverse().find(div => !div.classList.contains("hidden")) || main

      if (divs.length > 1 && div !== firstDiv) {
        div.scrollIntoView({ behavior: "smooth" })
      }
    }

    // klawiszowe skróty
    hotkeys("alt+n", (event, _handler) => {
      event.preventDefault()
      const archiveAndNextBtn = document.getElementById("archive_and_next")
      if (archiveAndNextBtn) {
        archiveAndNextBtn.click()
      }
    })
  }

  disconnect() {
    // Clean up event listener when the controller disconnects
    window.removeEventListener("turbo:before-stream-render", this.handleStreamRender)
    window.removeEventListener("popstate", this.handlePopState)
  }

  handleStreamRender(event) {
    // Check if the event is targeting our details frame
    const targetFrameId = event.target.getAttribute("target")
    console.log(targetFrameId)

    if (targetFrameId === "email_detail") {
      // Call showDetails to switch views
      this.showEmail()
    } else if (targetFrameId === "mail_emails_list") {
      this.hideEmail()
    } else if (targetFrameId === "email_reply") {
      this.hideReplyButtons()
    }
  }

  // scrollowanie do ostatniego rozwiniętego emaila (pierwszego nieodczytanego) w przypadku gdy weszliśmy do maila z listy
  scrollToEmailMutation(mutations, observer) {
    console.log(mutations)
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0 && Array.from(mutation.addedNodes).find(div => div.id === "email_detail")) {
        const main = document.querySelector("div[id=\"email-info\"]")
        const divs = Array.from(main.querySelectorAll("div[data-email-target=\"email\""))
        const firstDiv = divs[0] || main
        const div = divs.reverse().find(div => !div.classList.contains("hidden")) || main

        if (divs.length > 1 && div !== firstDiv) {
          div.scrollIntoView({ behavior: "smooth" })
        } else {
          main.scrollIntoView({ behavior: "smooth" })
        }

        observer.disconnect()
      }
    }
  }

  // scrollowanie do formatki odpowiedzi na maila
  scrollToReplyMutation(mutations, observer) {
    console.log(mutations)
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0 && Array.from(mutation.addedNodes).find(div => div.id === "email_reply")) {
        const reply = document.querySelector("#email_reply")
        console.log("hej mamy to", reply)

        observer.disconnect()
        setTimeout(() => {
          reply.scrollIntoView({ behavior: "smooth" })
        }, 300)
      }
    }
  }

  showEmail() {
    console.log("scrollujemy?", this.lastOpenedPage)
    const main = document.querySelector("main")
    if (main.scrollTop > 0) { this.listScrollPosition = document.querySelector("main").scrollTop }

    const emailList = document.getElementById("email_list")
    const emailDetail = document.getElementById("email_detail")
    const bulkOptions = document.getElementById("mail_email_options_div")

    emailList.classList.add("hidden")
    emailDetail.classList.remove("hidden")
    bulkOptions.classList.add("hidden")

    const observer = new MutationObserver(this.scrollToEmailMutation.bind(this))
    observer.observe(document.querySelector("main"), { childList: true, subtree: true })

    if (this.backUrl && this.emailId) {
      window.history.replaceState(null, "", this.backUrl)
      window.history.pushState(null, "", `/mail/emails/${this.emailId}`)
    }
  }

  hideEmail() {
    this.emailScrollPosition = document.querySelector("main").scrollTop
    const emailList = document.getElementById("email_list")
    const emailDetail = document.getElementById("email_detail")
    const bulkOptions = document.getElementById("mail_email_options_div")
    const emailReply = document.getElementById("email_reply")

    emailDetail.classList.add("hidden")
    emailList.classList.remove("hidden")
    bulkOptions.classList.remove("hidden")
    // ramki odpowiedzi nie ma na kazdym ekranie poczty (np. gdy user nie ma przypisanej
    // skrzynki, akcja "nowa wiadomosc" przekierowuje i turbo-frame sie nie renderuje)
    if (emailReply) { emailReply.innerHTML = "" }

    if (!this.hideEmailClick && this.backUrl) {
      this.hideEmailClick = true
      window.history.back()
      document.querySelector("main").scrollTo(0, parseInt(this.listScrollPosition, 10))
    }
  }

  hideReplyButtons() {
    this.emailScrollPosition = document.querySelector("main").scrollTop
    const observer = new MutationObserver(this.scrollToReplyMutation.bind(this))
    observer.observe(document.querySelector("main"), { childList: true, subtree: true })

    const emailReplyButtons = document.getElementById("email_reply_full")
    emailReplyButtons?.classList?.add("hidden")
  }

  showReplyButtons() {
    const emailReplyButtons = document.getElementById("email_reply_full")
    const emailReply = document.getElementById("email_reply")
    emailReplyButtons?.classList?.remove("hidden")
    emailReply?.classList?.add("hidden")
    document.querySelector("main").scrollTo(0, parseInt(this.emailScrollPosition, 10))
    if (emailReply) { emailReply.innerHTML = "" }
  }

  setId(event) {
    this.emailId = event.params.emailId
    this.backUrl = event.params.backUrl
  }

  handlePopState(event) {
    if (this.hideEmailClick) {
      this.hideEmailClick = false
      return
    }
    const button = document.getElementById("back_button")
    if (button && button.offsetParent) {
      event.preventDefault()
      button.click()
    }
  }
}
